
const useStyles = theme => ({
  intakeFormContainer: { padding: '2rem', margin: '0 auto' },
sronly: {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
}
});

export default useStyles;
